import { KeywordAutoCorrection } from '../get-data/transform/keyword-auto-correction';

export const UPDATE_KEYWORD_CORRECTION = 'UPDATE_KEYWORD_CORRECTION';

type KeywordCorrectionType = {
    autoCorrectInitial?: KeywordAutoCorrection;
    autoCorrectUndone?: { correctedKeyword: string };
    autoCorrectRedone?: { correctedKeyword: string };
};

const initialState: KeywordCorrectionType = {};

export const updateKeywordSuggestion = (payload: KeywordCorrectionType) => ({
    type: UPDATE_KEYWORD_CORRECTION,
    payload,
});

export default (
    state: KeywordCorrectionType = initialState,
    action: { type: string; payload: KeywordCorrectionType }
) => (action.type === UPDATE_KEYWORD_CORRECTION ? { ...state, ...action.payload } : state);
